export default "__VITE_ASSET__BbhxQL$K__"